import { CapoPlugin } from "/builds/synthese-et-medias/data-center-front/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];